import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import Swal from "sweetalert2";
import { useAuth } from "../contexts/AuthContext";
import { useLoading } from "../contexts/LoadingContext";

const ScopeProtectedRoute = ({ children, requiredScopes = [] }) => {
  const { isAuthenticated, isLoading: authLoading, hasScope } = useAuth();
  const [pageLoading, setPageLoading] = useState(true);
  const { setIsLoading } = useLoading();
  const navigate = useNavigate();

  useEffect(() => {
    const timeout = setTimeout(() => setPageLoading(false), 200);
    return () => clearTimeout(timeout);
  }, []);

  useEffect(() => {
    setIsLoading(authLoading || pageLoading);
  }, [authLoading, pageLoading, setIsLoading]);

  if (authLoading || pageLoading) {
    return (
      <div
        style={{
          position: "fixed",
          top: 0,
          left: 0,
          width: "100%",
          height: "100%",
          backgroundColor: "rgba(255, 255, 255, 0.9)",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          zIndex: 9999,
        }}
      >
        <div
          style={{
            width: "62px",
            height: "62px",
          }}
          className="spinner-border text-primary"
          role="status"
        >
          <span className="visually-hidden">Loading...</span>
        </div>
      </div>
    );
  }

  if (!isAuthenticated) {
    navigate("/login", { replace: true });
    return null;
  }

  if (!hasScope(requiredScopes)) {
    Swal.fire({
      icon: "error",
      title: "Access Denied",
      text: "Wala kang tamang permission para ma-access ang page na ito.",
      confirmButtonText: "OK",
      confirmButtonColor: "#3085d6",
      allowOutsideClick: false,
      allowEscapeKey: false,
    }).then(() => {
      navigate("/dashboard", { replace: true });
    });
    return null;
  }

  return children;
};

export default ScopeProtectedRoute;

